module.exports = __webpack_public_path__ + "img/farzana-christopher-144.7b09ffb0.jpg";